import { useState, useMemo, useCallback } from 'react'
import useGames from './useGames'

const useMatchFilters = () => {
  const { games, isLoading: isGamesLoading } = useGames()
  const [defaultGame, setDefaultGame] = useState(null)
  const [defaultStatus, setDefaultStatus] = useState(null)
  const [defaultType, setDefaultType] = useState(null)

  const defaultValues = useMemo(
    () => ({
      game: defaultGame,
      status: defaultStatus,
      type: defaultType,
    }),
    [defaultGame, defaultStatus, defaultType]
  )

  const filterConfig = useMemo(
    () => [
      {
        key: 'game',
        label: 'calendar.filter.game',
        options: games && games.length > 0 ? games : [],
        placeholder:
          games && games.length === 0 ? 'No games available' : 'Select game',
      },
      {
        key: 'status',
        label: 'game.tournaments.filters.status',
        options: [
          { id: 'soon', value: 'Soon' },
          { id: 'ended', value: 'Ended' },
          { id: 'live', value: 'Live' },
          { id: 'canceled', value: 'Canceled' },
        ],
        placeholder: 'Select status',
      },
      {
        key: 'type',
        label: 'community.status.all',
        options: [
          { id: 0, value: 'Show all matches' },
          { id: 1, value: 'Show only my matches' },
        ],
        placeholder: 'Select type',
      },
    ],
    [games]
  )

  const handleFiltersChange = useCallback(
    ({ game, status, type }, setFilters) => {
      setDefaultGame(game)
      setDefaultStatus(status)
      setDefaultType(type)

      // Convert to the format expected by the hook
      const filters = {
        currentGame: game?.id || '',
        currentState: status?.id || '',
        myMatches: type?.id || 0,
        fromDateValue: null,
        toDateValue: null,
      }

      setFilters(filters)
    },
    []
  )

  return {
    defaultValues,
    filterConfig,
    handleFiltersChange,
    games,
    isGamesLoading,
  }
}

export default useMatchFilters
